import React from 'react';
import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';

const bounce = keyframes`
  0%, 100% { transform: scaleY(0.3); }
  50% { transform: scaleY(1); }
`;

const BARS = [
  { delay: '0s', duration: '0.9s' },
  { delay: '0.2s', duration: '1.1s' },
  { delay: '0.4s', duration: '0.8s' },
];

const EqualizerBars = ({ color, size = 12 }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '2px', width: size, height: size }}>
    {BARS.map((bar, i) => (
      <Box
        key={i}
        sx={{
          flex: 1,
          height: '100%',
          backgroundColor: color,
          transformOrigin: 'bottom',
          animation: `${bounce} ${bar.duration} ease-in-out infinite`,
          animationDelay: bar.delay,
        }}
      />
    ))}
  </Box>
);

export default EqualizerBars;
